module.exports = __webpack_public_path__ + "static/media/logo2.63637d64.png";